import React from 'react';
import styled, { css, DefaultTheme, StyledComponent } from 'styled-components';
import { EllipsisTooltip } from '@components/common';

export const Wrapper: StyledComponent<'div', DefaultTheme, {}> = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 8px;
  border: 1px solid rgb(0 0 0 / 15%);
  padding: 8px;
  height: 100%;
  overflow: scroll;
  background: #fff;
  color: rgb(0 0 0 / 88%);
`;

export const TableHeader: StyledComponent<'div', DefaultTheme, {}> = styled.div`
  display: flex;
  background: rgb(0 0 0 / 4%);
`;

export const TableTitle: StyledComponent<'div', DefaultTheme, {}> = styled.div`
  line-height: 28px;
  font-size: 20px;
  padding-left: 4px;
`;

// header renderers
export const CommonHeaderRendererWrapper: StyledComponent<'div', DefaultTheme, {}> = styled.div`
  color: rgb(0 0 0 / 45%);
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  display: flex;
  gap: 10px;
  width: 100%;
`;

// cell renderers
export const CommonCellRendererWrapper = styled(EllipsisTooltip).attrs(
  (props: { style?: React.CSSProperties }) => ({
    style: props.style,
  }),
)`
  color: #1f1f1f;
  line-height: 22px;

  ${({ style }) => {
    if (style) {
      return css({
        ...style,
      });
    }
    return;
  }}
`;
